<template>
    <section :class="[namespace(), skinStyle]">
        <ul :class="groupClasses">
            <li
                :class="[
                    mdsNS('list-group__item'),
                    item.click === 'disabled'
                        ? mdsNS('list-group__item--disabled')
                        : '',
                    namespace('group__item')
                ]"
                v-for="item in listData"
                :key="item.id"
                @click.stop="click(item)"
            >
                <template v-if="item.click === false">
                    <span
                        :class="[
                            mdsNS('list-group__item-text'),
                            namespace('group__item-text')
                        ]"
                        v-html="item.name"
                    ></span>
                </template>
                <template v-else-if="item.isNavigation">
                    <div
                        :class="[
                            mdsNS('list-group__link'),
                            namespace('__link')
                        ]"
                    >
                        <div
                            :class="[
                                mdsNS('list-group__item-label'),
                                namespace('__item-label')
                            ]"
                        >
                            {{ item.title }}
                        </div>
                        <div
                            :class="[
                                mdsNS('list-group__item-label'),
                                namespace('__item-label'),
                                namespace('__current-selection')
                            ]"
                        >
                            {{ item.name }}
                        </div>
                        <span :class="namespace('__icon-wrapper')">
                            <svg :class="mdsNS('icon')" aria-labelledby="title">
                                <title>{{ item.name }}</title>
                                <use xlink:href="#caret-right--s"></use>
                            </svg>
                        </span>
                    </div>
                </template>
                <template v-else>
                    <a
                        href="javascript:void(0)"
                        :class="[
                            mdsNS('list-group__link'),
                            item.selected
                                ? mdsNS('list-group__item--active')
                                : ''
                        ]"
                    >
                        <span
                            :class="[
                                mdsNS('list-group__item-text'),
                                namespace('group__item-text')
                            ]"
                            v-html="item.name"
                        ></span>
                        <svg
                            v-if="item.selected"
                            :class="mdsNS('icon list-group__active-icon')"
                            aria-hidden="true"
                        >
                            <use xlink:href="#check--s"></use>
                        </svg>
                    </a>
                </template>
                <ul v-if="item.children">
                    <li
                        :class="[
                            mdsNS('list-group__item'),
                            namespace('group__item')
                        ]"
                        v-for="list in item.children"
                        :key="list.id"
                        @click.stop="click(list, item)"
                    >
                        <a
                            href="javascript:void(0)"
                            :class="[
                                mdsNS('list-group__link'),
                                list.selected
                                    ? mdsNS('list-group__item--active')
                                    : ''
                            ]"
                        >
                            <span
                                :class="[
                                    mdsNS('list-group__item-text'),
                                    namespace('group__item-text')
                                ]"
                                v-html="list.name"
                            ></span>
                        </a>
                        <svg
                            v-if="list.selected"
                            :class="mdsNS('icon list-group__active-icon')"
                            aria-hidden="true"
                        >
                            <use xlink:href="#check--s"></use>
                        </svg>
                    </li>
                </ul>
            </li>
        </ul>
    </section>
</template>
<script>
import utils from '../../utils';
import mixins from '../mixins';
export default {
    name: 'markets-ui-list',
    mixins: [mixins],
    props: {
        dataModel: {
            type: Array,
            required: true
        },
        size: {
            type: String,
            default: '',
            validator: function(value) {
                return !value || utils.inArray(['small', 'large'], value) > -1;
            }
        }
    },
    data() {
        return {
            listData: []
        };
    },
    computed: {
        groupClasses() {
            const cls = [this.mdsNS('list-group')];
            if (this.size) {
                cls.push(this.mdsNS(`list-group--${this.size}`));
            }
            cls.push(this.namespace('group'));
            return cls;
        }
    },
    created() {
        this.namespace = utils.namespace('ui-list', false);
        this.listData = utils.extend(true, [], this.dataModel);
    },
    watch: {
        dataModel: {
            handler(value) {
                this.listData = utils.extend(true, [], value);
            },
            deep: true
        }
    },
    methods: {
        click(item) {
            if (item.click && item.click !== 'disabled') {
                this.$emit('click', item);
                return;
            }
            if (!item.selected) {
                for (const d of this.listData) {
                    if (d.id === item.id) {
                        d.selected = true;
                    } else {
                        d.selected = false;
                    }
                }
                this.$emit('change', item);
            }
        }
    }
};
</script>
<style lang="scss">
$namespace: 'markets-ui-list';
@mixin group-item-font {
    font-family: $mds-font-family-sans-serif;
    font-size: $mds-font-size-m;
}
@import '../../mds/constants';
.#{$namespace} {
    &-group {
        margin-bottom: 0px;
        &__item {
            @include group-item-font;
            ul {
                padding-left: 40px;
                .#{$namespace}-group__item {
                    border: none;
                    @include group-item-font;
                }
            }
        }
    }
    .mds-list-group--small {
        .#{$namespace}-group__item {
            padding: 3px 0;
            font-size: $mds-font-size-s;
        }
    }
    &__item--no-click {
        cursor: default;
    }
    &__item-label {
        padding-top: $mds-space-inset-1-x;
        font-size: $mds-font-size-s;
        font-weight: 400;
        cursor: pointer;
    }
    &__current-selection {
        font-weight: $mds-font-weight-bold;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: calc(100% - 20px);
    }
    &__icon-wrapper {
        display: inline-block;
        position: absolute;
        right: 0;
        top: calc(50% - 8px);
        svg {
            height: $mds-size-icon-s;
            width: $mds-size-icon-s;
            fill: $mds-color-neutral-50;
        }
        svg:hover {
            fill: $mds-text-color-link-default;
        }
    }
}
</style>
